import { createRouter } from '@tanstack/react-router'
import { InitialPagePendingScreen } from 'shared/ui/InitialPagePendingScreen'
import { rootRoute } from './routes/__root'
import { indexRoute } from './routes/index'
import { authRoute } from './routes/auth'
import { floor6MapRoute } from './routes/floor6Map'
import { webviewRoute } from './routes/webview'

const routeTree = rootRoute.addChildren([indexRoute, authRoute, webviewRoute, floor6MapRoute])

export const router = createRouter({
  routeTree,
  defaultPendingComponent: InitialPagePendingScreen,
  defaultPendingMs: 0,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
